var _templateObject = _taggedTemplateLiteralLoose(['\n    height: ', ';\n    max-height: 80px;\n    width: ', ';\n    @media(max-width: 700px){\n      width: 86px;\n    }\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  '], ['\n    height: ', ';\n    max-height: 80px;\n    width: ', ';\n    @media(max-width: 700px){\n      width: 86px;\n    }\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  ']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled, { withTheme } from 'styled-components';
import Simply from './simply.svg';
import SimplyWhite from './simply-white.svg';
import { wrapAssetPath } from '../../../utils';

var CenteredLogo = function CenteredLogo(props) {
  var white = props.white,
      logoPathPrefix = props.logoPathPrefix,
      theme = props.theme,
      _props$height = props.height,
      height = _props$height === undefined ? 'auto' : _props$height,
      _props$width = props.width,
      width = _props$width === undefined ? 'auto' : _props$width,
      className = props.className;
  var CenteredImg = styled.img(_templateObject, height, width);
  var path = white ? SimplyWhite : Simply;
  var fullPath = logoPathPrefix ? '' + logoPathPrefix + path : wrapAssetPath(theme, path);

  if (theme.isSimplyBased === true) {
    return React.createElement(CenteredImg, {
      className: className,
      src: fullPath,
      alt: 'Simply'
    });
  }

  return null;
};

export default withTheme(CenteredLogo);